import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { TabPanel, a11yProps } from '../../ui';
import Frames from './frames/frames';
import Lenses from './lenses/lenses';
import Contacts from './contacts/contacts';
import Accessory from './accessories/accessory';
import Catalog from './catalog';
import { useSearchParams } from 'react-router-dom';

export default function Inventory() {
    const [searchParams] = useSearchParams();
    const [value, setValue] = React.useState(() => {
        const subtab = searchParams.get('subtab');
        const subtabIndices = {
            'frames': 0,
            'lenses': 1,
            'contacts': 2,
            'accessories': 3,
            'catalog': 4,
        };
        return subtabIndices[subtab] || 0;
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} >
                    <Tab label="Frames" {...a11yProps('inventory',0)} />
                    <Tab label="Lens" {...a11yProps('inventory',1)} />
                    <Tab label="Contacts" {...a11yProps('contacts',2)} />
                    <Tab label="Accessories" {...a11yProps('inventory',3)} />
                    <Tab label="Catalog" {...a11yProps('catalog',4)} />
                </Tabs>
            </Box>
            <TabPanel idfor='Frames' value={value} index={0}>
                <Frames />
            </TabPanel>
            <TabPanel idfor='Lens' value={value} index={1}>
                <Lenses />
            </TabPanel>
            <TabPanel idfor='Contacts' value={value} index={2}>
                <Contacts />
            </TabPanel>
            <TabPanel idfor='Accessories' value={value} index={3}>
                <Accessory />
            </TabPanel>
            <TabPanel idfor='Catalog' value={value} index={4}>
                <Catalog />
            </TabPanel>           
        </Box>
    );
}
